import type {
  FlagGlossaryEntry,
  FlagGlossaryKpiCounts,
} from './flagGlossary.types';

export const computeFlagGlossaryKpiCounts = (
  entries: FlagGlossaryEntry[],
): FlagGlossaryKpiCounts => ({
  total: entries.length,
  thresholded: entries.filter((entry) => entry.isAmountThresholdable).length,
  turnedOff: entries.filter((entry) => !entry.isActive).length,
});
